/* eslint-disable react/jsx-no-bind */
/* eslint-disable prettier/prettier */
import React, { useEffect, useState } from 'react'
import { Col, Row } from 'react-bootstrap'

import Button from 'components/Button'
import Modal from 'components/Modal'

import styles from './styles.module.scss'

const RecommendModal = ({
  show,
  toggleModal,
  clients,
  onConfirm,
  recomendedResources
}) => {
  // Data validation at component boundaries
  const validatedClients = Array.isArray(clients) ? clients : []
  const validatedRecomendedResources = Array.isArray(recomendedResources)
    ? recomendedResources
    : []

  // This modal previously used `react-multi-select-component` which was throwing
  // "Minified React error #130" in production for this app. Since this modal
  // doesn't need to be fancy, we render a simple checkbox list instead.
  const [selectedValues, setSelectedValues] = useState([])

  // Set of clients who were already recommended this content when the modal
  // opened. Used for the stable ordering below (already-recommended first), so
  // rows don't reshuffle as the coach checks/unchecks during this session.
  const recommendedIds = new Set(
    validatedRecomendedResources
      .map(r => Number(r?.userId || r?.User?.id || 0))
      .filter(Boolean)
  )

  useEffect(() => {
    // Preselect already-recommended users (value is userId)
    setSelectedValues(Array.from(recommendedIds))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [recomendedResources])

  const options = validatedClients
    .filter(client => client && client.id)
    .map(client => {
      const firstName = String(client.firstName || '')
      const lastName = String(client.lastName || '')
      // Clients invited by email only (bulk-invite flow) have no name yet, so
      // fall back to their email before the generic "Unknown User" label.
      const email = String(client.email || '')
      return {
        label: `${firstName} ${lastName}`.trim() || email || 'Unknown User',
        // Sort key: first name when present, otherwise the label (email).
        sortKey: (firstName || email || 'Unknown User').toLowerCase(),
        value: Number(client.id)
      }
    })

  // Already-recommended first (alphabetical by first name), then the rest
  // (alphabetical by first name).
  const sortedOptions = [...options].sort((a, b) => {
    const aRec = recommendedIds.has(a.value)
    const bRec = recommendedIds.has(b.value)
    if (aRec !== bRec) return aRec ? -1 : 1
    return a.sortKey.localeCompare(b.sortKey)
  })

  async function handleRecommendationSubmit() {
    await onConfirm(selectedValues)
    await toggleModal()

    setSelectedValues([])
  }

  const toggleSelectedValue = value => {
    setSelectedValues(prev => {
      if (!Array.isArray(prev)) return [value]
      return prev.includes(value)
        ? prev.filter(v => v !== value)
        : [...prev, value]
    })
  }

  // Don't render if show is false
  if (!show) {
    return null
  }

  return (
    <Modal show={show} closeModal={toggleModal}>
      <Row>
        <Col xs={12}>
          <div className="d-flex align-items-center mb-10">
            <Col xs={12}>
              <p className={styles.modalTitle}>
                Recommend Content
              </p>
            </Col>
          </div>
          <div className="d-flex align-items-center mb-30">
            <Col xs={12}>
              <div style={{ maxHeight: 320, overflowY: 'auto' }}>
                {sortedOptions.map(opt => (
                  <label
                    key={String(opt.value)}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 10,
                      padding: '6px 0',
                      cursor: 'pointer'
                    }}
                  >
                    <input
                      type="checkbox"
                      checked={selectedValues.includes(opt.value)}
                      onChange={() => toggleSelectedValue(opt.value)}
                    />
                    <span>{opt.label}</span>
                  </label>
                ))}
              </div>
            </Col>
          </div>
          <div className="d-flex justify-content-end align-items-center">
            <Button
              variant="link"
              smallPadding
              onClick={toggleModal}
            >
              Cancel
            </Button>
            <Button
              variant="secondary"
              smallPadding
              type="submit"
              onClick={handleRecommendationSubmit}
            >
              Send File
            </Button>
          </div>
        </Col>
      </Row>
    </Modal>
  )
}

export default RecommendModal
